import React from 'react';
import { Box, Container, Typography, Grid, Paper } from '@mui/material';
import { motion } from 'framer-motion';
import SchoolIcon from '@mui/icons-material/School';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import BusinessIcon from '@mui/icons-material/Business';
import GroupsIcon from '@mui/icons-material/Groups';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';

const ProfessionalFunnel = () => {
  const steps = [
    {
      title: '1. Aprende y Certifícate',
      desc: 'Fórmate en la Academia Hitpoly con cursos de alto valor: marketing digital, diseño, programación, IA y más. Estudia a tu ritmo y obtén certificaciones.',
      icon: SchoolIcon,
      color: '#6C4DE2'
    },
    {
      title: '2. Construye tu Perfil',
      desc: 'Crea tu portafolio profesional y completa tu perfil dentro de la plataforma. Las empresas del ecosistema verán tus habilidades verificadas.',
      icon: WorkspacePremiumIcon,
      color: '#E67E22'
    },
    {
      title: '3. Conecta en la Comunidad',
      desc: 'Interactúa en el Muro, resuelve dudas de otros miembros, comparte casos de éxito y gana reputación como experto para posicionarte.',
      icon: GroupsIcon,
      color: '#1877F2'
    },
    {
      title: '4. Consigue Clientes',
      desc: 'Aplica directamente a las ofertas publicadas por empresas en la Bolsa de Profesionales o permite que te contacten gracias a tu perfil destacado.',
      icon: BusinessIcon,
      color: '#00A86B'
    },
    {
      title: '5. Escala tu Carrera',
      desc: 'A medida que acumulas proyectos y reseñas positivas, tu tarifa aumenta. Hitpoly se convierte en tu plataforma de lanzamiento profesional permanente.',
      icon: RocketLaunchIcon,
      color: '#F21C63'
    }
  ];

  return (
    <Box sx={{ background: '#0B0914', py: 10, color: '#fff', borderTop: '1px solid rgba(255,255,255,0.05)' }}>
      <Container maxWidth="lg">
        <Grid container spacing={6} alignItems="center" direction={{ xs: 'column-reverse', md: 'row' }}>
          
          <Grid item xs={12} md={7}>
            <Box sx={{ position: 'relative' }}>
              {/* Línea conectora */}
              <Box sx={{ position: 'absolute', right: { xs: 'auto', md: '39px' }, left: { xs: '39px', md: 'auto' }, top: '20px', bottom: '20px', width: '2px', background: 'linear-gradient(180deg, #6C4DE2, #1877F2, #00A86B)' }} />
              
              {steps.map((step, index) => (
                <motion.div 
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.2 }}
                >
                  <Box sx={{ display: 'flex', flexDirection: { xs: 'row', md: 'row-reverse' }, gap: 3, mb: index !== steps.length - 1 ? 4 : 0, position: 'relative', zIndex: 1 }}>
                    <Box 
                      sx={{ 
                        width: 80, 
                        height: 80, 
                        borderRadius: '50%', 
                        background: '#13111C',
                        border: `2px solid ${step.color}`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: step.color,
                        flexShrink: 0
                      }}
                    >
                      <step.icon fontSize="large" />
                    </Box>
                    <Paper 
                      elevation={0}
                      sx={{ 
                        p: 3, 
                        background: 'rgba(255,255,255,0.03)', 
                        border: '1px solid rgba(255,255,255,0.05)', 
                        borderRadius: '16px',
                        flexGrow: 1,
                        textAlign: { xs: 'left', md: 'right' }
                      }}
                    >
                      <Typography variant="h6" fontWeight="bold" mb={1}>{step.title}</Typography>
                      <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.6)' }}>{step.desc}</Typography>
                    </Paper>
                  </Box>
                </motion.div>
              ))}
            </Box>
          </Grid>

          <Grid item xs={12} md={5}>
            <motion.div initial={{ opacity: 0, x: 50 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} style={{ textAlign: 'right' }}>
              <Typography variant="caption" sx={{ color: '#29B6F6', fontWeight: 'bold', letterSpacing: 1 }}>PARA PROFESIONALES</Typography>
              <Typography variant="h3" fontWeight={800} mt={2} mb={3}>
                La Ruta Completa Hacia tu Éxito
              </Typography>
              <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.7)', mb: 4, lineHeight: 1.8 }}>
                No solo te ofrecemos cursos; te damos las herramientas para conseguir resultados reales. Desde el momento en que aprendes hasta que firmas contratos con empresas globales a través de nuestra Bolsa de Profesionales.
              </Typography>
            </motion.div>
          </Grid>

        </Grid>
      </Container>
    </Box>
  );
};

export default ProfessionalFunnel;
